import SelectRole from "components/register/select-role";
import { useTranslation } from "react-i18next";
import styles from "styles/onboarding.module.css";
import { NavLink } from "react-router";
import LanguageSelector from "components/functional/language-selector";
import useIsMobile from "hooks/detect-mobile-screen";
import RegisterPresentation from "components/register/register-presentation";
import { useNavigate } from "react-router";
import { ChevronLeft } from "lucide-react";

const Register = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile(980);
  const navigate = useNavigate();

  const roles = [
    {
      name: "admin",
      title: t("register.role-step.admin-role.title"),
      description: t("register.role-step.admin-role.description"),
      url: "/register-admin",
    },
    {
      name: "player",
      title: t("register.role-step.player-role.title"),
      description: t("register.role-step.player-role.description"),
      url: "/register-player",
    },
  ];

  return (
    <div className={styles["register-container"]}>
      <section className={styles["register-content"]}>
        <div className={styles["content-header"]}>
          <div className="company-logo">
            <img src="logo.png" width="26" height="24" alt="" />
            <h1 className="title-2-variant">Kompa</h1>
          </div>
          {!isMobile && (
            <NavLink className="link-1" to="/login">
              {t("actions.sign-in")}
            </NavLink>
          )}
          <LanguageSelector></LanguageSelector>
        </div>
        <div className={styles["content-actions"]}>
          <article className={styles["role-selection"]}>
            <section className={styles["role-header"]}>
              <h2 className="title-1-variant">
                {t("register.role-step.title")}
              </h2>
              <p className="subtitle-1-variant">
                {t("register.role-step.description")}
              </p>
            </section>
            <section className={styles["role-choose"]}>
              {roles.map((item) => (
                <SelectRole role={item} />
              ))}
            </section>
            <div className={styles["role-back-cta"]}>
              <button
                className="btn btn--secondary btn--icon-label"
                onClick={() => navigate("/login")}
              >
                <ChevronLeft size={20} />
                <p className="subtitle-1-variant">{t("actions.back")}</p>
              </button>
            </div>
          </article>
        </div>
      </section>
      {!isMobile && <RegisterPresentation />}
    </div>
  );
};

export default Register;
